import { Component, OnInit } from '@angular/core';
import { CommsService } from '../../services/comms.service';
import { Router } from '@angular/router';
import { SessionType } from '../models/SessionType';
import * as moment from 'moment';
import { SessionInfoVM } from '../models/SessionInfoVM';

@Component({
  selector: 'layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  public session: SessionInfoVM;
  public sessionType: string;
  public timeRemaining: string;
  public endingSoon: boolean = false;
  public comms: CommsService;

  constructor(
    private router: Router,
    private commsService: CommsService
  ) {
    this.comms = commsService;
  }

  ngOnInit(): void {
    this.session = this.commsService.activeSessionInfo;
    switch (this.session.sessionType) {
      case SessionType.video:
        this.sessionType = "Video Session";
        break;
      case SessionType.audio:
        this.sessionType = "Audio Session";
        break;
      case SessionType.im:
        this.sessionType = "Instant Message Session";
        break;
    }

    this.calculateTimeRemaining();
  }

  calculateTimeRemaining() {
    this.timeRemaining = "00:00:00";
    var timeRemainingThreahold = 300000;                  // 5 mins warning
    var end = moment(this.session.combinedEndDateTime);   // official end time

    // update clock
    if (moment() > end) {
      var negativeDiff = moment.utc(moment().diff(moment(end))).format("HH:mm:ss");
      this.timeRemaining = "-" + negativeDiff;
    }
    else {
      this.timeRemaining = moment.utc(end.diff(moment())).format("HH:mm:ss")
    }

    // identify session end warning and hard stop
    var millisecondsRemaining = moment(this.session.combinedEndDateTime).diff(moment.utc());
    if (millisecondsRemaining <= -600000) {               // -10 mins hard stop
      localStorage.removeItem('sessionToken');
      this.router.navigateByUrl('/');
    }
    else if (millisecondsRemaining > 0 && millisecondsRemaining <= timeRemainingThreahold) {
      this.endingSoon = true;
    }

    var self = this;
    setTimeout(function () {
      self.calculateTimeRemaining();
    }, 1000);
  }


}
